import ng from 'angular';
import { IAnexo } from '../../../Anexos/models/anexo.model';

export class MeurhAdmissoesDocumentosanexosFormController implements ng.IController {

    static $inject = ['$scope'];

    public entity: any;
    public entityanexo: IAnexo;
    public formAnexo: angular.IFormController;
    public busy: boolean;
    public busyTipoDocumentos: boolean;
    public tiposdocumentosrequeridos: Array<any>;
    public alterouanexo: boolean;
    public validate: number = 0; // conta quantos erros há em documentos anexos

    constructor(
        public $scope: angular.IScope,
    ) { }
}
